<template>
  <div class="top-contrainer">
    <div class="layout-header">
      <div class="layout-header-system">
        <img
          v-if="projectInfoConfig.fullLogo"
          class="layout-header-system-logo"
          :src="projectInfoConfig.fullLogo"
          @click="goStaticHome"
        />
      </div>
      <div class="layout-header-user-info">
        <el-dropdown>
          <span class="el-dropdown-link" :style="{ cursor: 'pointer' }">
            <span class="icon-middle" style="width:30px;margin-right: 10px;">
              <img src="../../assets/default-icon.png" alt="" />
            </span>
            {{ userInfo.tel | phoneFilter }}<i class="el-icon-arrow-down el-icon--right" v-if="!isThird"></i>
          </span>
          <el-dropdown-menu slot="dropdown" v-if="!isThird">
            <el-dropdown-item>
              <div class="header-portrait">
                <div class="icon-middle" style="width:30px;margin-left:-5px;margin-right: 10px;">
                  <img src="../../assets/default-icon.png" alt="" />
                </div>
                <div>
                  <p>{{ userInfo.tel | phoneFilter }}</p>
                </div>
              </div>
            </el-dropdown-item>
            <el-dropdown-item v-if="!projectInfoConfig.hideLogout">
              <div @click="loginOut" class="user-dropdown">
                <a>退出</a>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <router-view />
  </div>
</template>

<script>
import { projectInfoConfig } from '@/constant';
import { mapGetters } from 'vuex';
import { phoneFilter } from '@/filter.js';

export default {
  data() {
    return {
      projectInfoConfig,
      userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}') || {}
    };
  },
  filters: { phoneFilter },
  computed: {
    ...mapGetters(['isThird'])
  },
  methods: {
    goStaticHome() {
      if (this.isThird) {
        return;
      }
      var locationHref = window.location.href;
      location.href = locationHref.slice(0, locationHref.indexOf('/home.html')) + '/index.html';
    },
    loginOut() {
      this.httpGet('admin/logout').then(data => {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('_TOKEN_');
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
        sessionStorage.removeItem('userInfo');
        this.userInfo = {};
        this.goStaticHome();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.top-contrainer {
  position: relative;

  .layout-header {
    height: 60px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;

    .layout-header-user-info {
      display: flex;
      align-items: center;

      .system-expired-info {
        margin-right: 30px;

        .vip-time-info {
          display: flex;
          align-items: center;
          height: 24px;

          .vip-time-info-content {
            color: #fedda9;
            font-size: 12px;
            height: 24px;
            line-height: 24px;
            background: linear-gradient(270deg, #383e49 0%, #505868 100%);
            border-radius: 2px 0px 0px 2px;
            padding: 0 10px;

            .vip-time-info-img {
              width: 22px;
            }
          }
          .vip-time-info-renew-btn {
            color: #172237;
            font-size: 12px;
            line-height: 24px;
            background: #fedda9;
            border-radius: 0px 2px 2px 0px;
            padding: 0 10px;
            cursor: pointer;
          }
        }

        .vip-free-surplus {
          display: flex;
          align-items: center;
          color: #4e555b;
          font-size: 14px;
          line-height: 20px;

          .el-icon-question {
            position: relative;
            top: -1px;
            font-size: 16px;
            color: #e6a23c;
            cursor: pointer;
            margin-right: 2px;
          }

          .vip-free-surplus-btn {
            color: #172237;
            font-size: 12px;
            height: 24px;
            line-height: 24px;
            margin-left: 10px;
            background-color: #fedda9;
            border-radius: 2px;
            padding: 0 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.layout-header-system {
  display: flex;
  align-items: center;
  margin: 0 50px 0 10px;

  .layout-header-system-logo {
    height: 24px;
    cursor: pointer;
    margin-right: 10px;
  }
  .layout-header-system-label {
    color: #172237;
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
  }
  .layout-header-system-enterprise {
    color: #3f6efc;
    font-size: 14px;
    line-height: 20px;
    border: 1px solid #3f6efc;
    border-radius: 8px 0 8px 0;
    padding: 0 10px;
    margin-left: 10px;
  }
}
.header-portrait {
  display: flex;
  .pic {
    width: 32px;
    height: 32px;
    border-radius: 32px;
    margin-right: 10px;
    background-color: #f2f2f2;
    display: inline-block;
  }
  .tel {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/otherSysLayout/Layout.vue